import React, {ReactNode} from 'react';
import styles from './Input.module.css';

// Input 컴포넌트의 props 타입 정의
// HTMLInput의 기본 속성들을 상속받고 추가 속성 정의
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string;      // 입력 필드의 레이블 (선택적)
    error?: string;      // 에러 메시지 (선택적)
    writable?: boolean;  // 입력 가능 여부 (선택적)
    fullWidth?: boolean; // 전체 너비 사용 여부 (선택적)
    leftIcon?: ReactNode;    // 왼쪽 아이콘 (선택적)
    rightIcon?: ReactNode;   // 오른쪽 아이콘 (선택적)
    rightButton?: ReactNode; // 오른쪽 버튼 (선택적)
}

// 입력창 컴포넌트
const Input: React.FC<InputProps> = ({
                                         label,
                                         error,
                                         fullWidth = false,      // 기본값: false
                                         writable = true,        // 기본값: true
                                         leftIcon,
                                         rightIcon,
                                         rightButton,
                                         className,
                                         ...props               // 나머지 HTML input 속성들
                                     }) => {
    return (
        <div className={`${styles.container} ${fullWidth ? styles.fullWidth : ''}`}>
            {/* 레이블 영역 */}
            {label && <label className={styles.label}>{label}</label>}

            {/* 입력 필드 래퍼 */}
            <div className={styles.inputWrapper}>
                {/* 왼쪽 아이콘 */}
                {leftIcon && <div className={styles.leftIcon}>{leftIcon}</div>}

                {/* 입력 필드 */}
                <input
                    className={`
                        ${styles.input}
                        ${error ? styles.error : ''}                               // 에러 상태
                        ${leftIcon ? styles.hasLeftIcon : ''}                      // 왼쪽 아이콘 있음
                        ${(rightIcon || rightButton) ? styles.hasRightIcon : ''}   // 오른쪽 아이콘/버튼 있음
                        ${!writable ? styles.notWritable : ''}                     // 입력 불가능 상태
                        ${className || ''}                                         // 외부에서 전달된 클래스
                    `}
                    readOnly={!writable}  // 입력 가능 여부 설정
                    {...props}            // 나머지 props 전달
                />

                {/* 오른쪽 아이콘 */}
                {rightIcon && <div className={styles.rightIcon}>{rightIcon}</div>}

                {/* 오른쪽 버튼 */}
                {rightButton && <div className={styles.rightButton}>{rightButton}</div>}
            </div>

            {/* 에러 메시지 표시 영역 */}
            {error && <span className={styles.errorMessage}>{error}</span>}
        </div>
    );
};

export default Input;